import {
  Button,
  Heading,
  Modal,
  ModalContent,
  ModalOverlay,
  Stack,
  UseDisclosureReturn,
  useToast,
} from '@chakra-ui/react';

import { useCreateInstruction } from '../hooks/quote/useCreateInstruction';
import { InstructionInput, useInstructionForm } from '../hooks/quote/useInstructionForm';
import { InstructionForm } from './Forms/InstructionForm';
import { SimpleForm } from './SimpleForm';

type NewInstructionModalProps = UseDisclosureReturn & {
  defaultValues?: Partial<InstructionInput>;
};

export const NewInstructionModal = ({ defaultValues, onClose, isOpen }: NewInstructionModalProps) => {
  const toast = useToast();
  const { create, isLoading: isCreating } = useCreateInstruction();
  const { methods } = useInstructionForm(defaultValues);

  const onValid = async (values: InstructionInput) => {
    try {
      await create(values);
      onClose();
      methods.reset();
      toast({ title: 'Instruction created', status: 'success' });
    } catch (error) {
      toast({
        title: 'Error creating instruction template',
        description: error?.message,
        status: 'error',
      });
    }
  };

  const handleSubmit = methods.handleSubmit(onValid);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <SimpleForm defaultValues={defaultValues} {...methods} submitOnBlur={false}>
          <Stack as="form" w="full" h="full" p="6" spacing="8" alignItems="flex-start" onSubmit={handleSubmit}>
            <Heading as="h2" fontSize={20}>
              Create new instruction
            </Heading>

            <Stack direction="column" spacing={4} w="full">
              <InstructionForm />
              <Button type="submit" colorScheme="brand" alignSelf="flex-end" isLoading={isCreating}>
                Create template
              </Button>
            </Stack>
          </Stack>
        </SimpleForm>
      </ModalContent>
    </Modal>
  );
};
